import React from "react";
import Popupz from "../../atoms/Popupz";
import Buttonz from "../../atoms/Buttonz";
import SvgIcn from "../../../data/IconCompo";

function CheckEmailPopup({ onClose }) {
  return (
    <Popupz
    title="Check Your Email"
    text={
      <>
        We've sent password reset instructions to your email address.  <br /> 
        Please check your inbox and follow the link to reset your password.
      </>
    }
    onClose={onClose}
    popupId="login"
    // iconIllus="chara01"
  >

    </Popupz>
  );
}

export default CheckEmailPopup;
